/**
 * App Component
 * 
 * Root application component that sets up:
 * - Context providers
 * - Routing
 * - Global layout
 * 
 * The app uses a simple single-page structure since the funnel
 * handles its own internal navigation through steps.
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import { FunnelProvider } from './context/FunnelContext';
import FunnelPage from './components/FunnelPage';

// ============================================
// MAIN APP COMPONENT
// ============================================

/**
 * App - Root component that wraps everything
 */
function App() {
  return (
    // FunnelProvider gives all components access to funnel state
    <FunnelProvider>
      {/* Skip link for keyboard accessibility */}
      <a
        href="#main-content"
        className="skip-link"
      >
        Skip to main content
      </a>

      {/* Main application container */}
      <div className="min-h-screen bg-white" id="main-content">
        <Routes>
          {/* Main funnel route */}
          <Route path="/" element={<FunnelPage />} />
          
          {/* Redirect any other routes to the funnel */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </FunnelProvider>
  );
}

export default App;
